import { Component, OnInit, Input,Output, EventEmitter } from '@angular/core';
import {FormGroup} from '@angular/forms';
import{LoopBackAuth, listadosService, validacionService, estudianteService} from '../../shared/services/api-rest.service';
import{MessageService} from '../../shared/services/message.service';
import { isNull } from 'util';
/**
 * Seccion para ingresar datos principales de un Estudiante o Persona
 *
 * @export
 * @class DatosPrincipalesComponent
 * @implements {OnInit}
 */
@Component({
  selector: 'datos-principales',
  template: `
    <form name="form-inscripciones" [formGroup]="principales">
      <div class="row">
          <label class="col-4 col-sm-3 col-md-2 col-form-label text-right">
            Identificación: <span class="text-danger">*</span> 
          </label>
          <div class="col-4 col-sm-3 col-md-2 pr-0">
            <div class="input-group input-group-sm ">
                <select
                name="alumnoTipo"
                class="form-control"
                [style.border-radius]="'0px'"
                (change)="onChangeTipo($event.target.value)"
                formControlName="tipo">
                <option *ngFor="let item of identificaciones" [value]="item.id">{{item.descripcion | uppercase}}</option>
              </select>
            </div>
          </div>
          <div class="col-4 col-sm-6 col-md-2 pl-0">
            <div
              class="input-group input-group-sm"
              [ngClass]="{'showError': !principales.get('identificacion').valid && principales.get('identificacion').touched}" >
              <input
              type="text"
              [style.padding]="'0.35rem 0.5rem'"
              [style.border-radius]="'0px'"
              class="form-control"
              maxlength="{{maxLongitud}}"
              minlength="{{minLongitud}}"
              formControlName="identificacion"
              validarIdentificacion="{{principales.get('tipo').value}}"
              (blur)="validarUsuarioIdentificacion()"
              >
            </div>
            
          </div>
          <label class="col-4 col-sm-3 col-md-3 col-form-label text-right">
            Fecha de Nacimiento: <span class="text-danger">*</span> </label>
          <div class="col-8 col-sm-9 col-md-3">
              <div
              class="input-group input-group-sm mb-1"
              [ngClass]="{'showError': !principales.get('fechaNacimiento').valid && principales.get('fechaNacimiento').touched}" >
                <input
                type="text"
                class="form-control"
                [style.border-radius]="'0px'"
                formControlName="fechaNacimiento"
                placeholder="yyyy-mm-dd"
                ngbDatepicker #d="ngbDatepicker"
                (click)="onFechaNacimiento(d)"
                >
              </div>
            
          </div>
      </div>
      <div class="row">
        <label class="col-sm-2 col-form-label text-right">
        Apellidos: <span class="text-danger">*</span> </label>
        <div class="col-sm-4 pr-0">
          <div
            class="input-group input-group-sm "
            [ngClass]="{'showError': !principales.get('apellido').valid && principales.get('apellido').touched}" >
              <input
              type="text"
              [style.border-radius]="'0px'"
              class="form-control"
              formControlName="apellido"
              frmUppercase
              >
          </div>
        </div>
        <label class="col-sm-2 col-form-label text-right">
          Nombres: <span class="text-danger">*</span>
        </label>
        <div class="col-sm-4">
            <div
            class="input-group input-group-sm mb-1"
            [ngClass]="{'showError': !principales.get('nombre').valid && principales.get('nombre').touched}" >
            <input
            type="text"
            [style.border-radius]="'0px'"
            class="form-control"
            formControlName="nombre"
            frmUppercase
            >
          </div>
        </div>
      </div>
      
      <div class="row">
        <label class="col-sm-2 col-form-label text-right">
          Dirección: <span class="text-danger">*</span>
        </label>
        <div class="col-sm-6">
            <div
            class="input-group input-group-sm"
            [ngClass]="{'showError': !principales.get('direccion').valid && principales.get('direccion').touched}" >
              <input
              type="text"
              [style.border-radius]="'0px'"
              class="form-control"
              placeholder="Calle principal y calle secundaria"
              formControlName="direccion"
              frmUppercase
              >
            </div>
        </div>
        <label class="col-sm-2 col-form-label text-right">
          Sector/Barrio: <span class="text-danger">*</span>
        </label>
        <div class="col-sm-2">
            <div
            class="input-group input-group-sm"
            [ngClass]="{'showError': !principales.get('sector').valid && principales.get('sector').touched}" >
              <input
              type="text"
              [style.border-radius]="'0px'"
              class="form-control"
              formControlName="sector"
              frmUppercase
              >
            </div>
        </div>
        <label class="col-sm-2 col-form-label text-right">
              Genero: <span class="text-danger">*</span>  
          </label>
          <div class="col-sm-4 p-0 form-radio">
            <div class="radio radio-inline pt-1" *ngFor="let item of generos">
                <label>
                    <input type="radio" name="genero" [value]="item.id" formControlName="genero" >
                    <i class="helper"></i>{{item.descripcion | uppercase}}
                </label>
            </div>
          </div>
      </div>
      <hr/>
      <div class="row">
          <label class="col-sm-3 col-form-label text-right">
            Correo Estudiante:
          </label>

          <div class="col-sm-9">
              <div
              class="input-group input-group-sm"
              [ngClass]="{'showError': !principales.get('emailEstudiante').valid && principales.get('emailEstudiante').touched}" >
                <input
                type="text"
                class="form-control"
                [style.border-radius]="'0px'"
                formControlName="emailEstudiante"
                frmLowercase
                placeholder="Correo estudiante"
                >
              </div>
            </div>
          <label class="col-sm-3 col-form-label text-right">
            Correo Notificaciones: <span class="text-danger">*</span>
          </label>
          <div class="col-sm-9">
            <div 
              style="border: 1px solid #ccc; min-height: 25px; height:100%; padding-top:3px;"
              [ngClass]="{'showErrorBorde': principales.get('email').value ==''}">
              <span 
                style="border: 1px solid #4680ff;background: #4680ff; color:#fff; padding:0.5px 3px; margin:0px 2px;"
                *ngFor="let item of listaMails; index as i"> {{item}} 
                <span class="ml-1 cursor" (click)="deleteCorreoNotificacion(i)">x</span>
              </span>
              <input  
                type="text" 
                style="border: 1px solid #fff;"
                (focusout)="onCorreosNotificaciones($event)" 
                placeholder="Correo notificación">
            </div>
            
          </div>
          <!--div class="col-sm-9">
            <div
            class="input-group input-group-sm"
            [ngClass]="{'showError': !principales.get('email').valid && principales.get('email').touched}" >
              <input
              type="text"
              class="form-control"
              [style.border-radius]="'0px'"
              formControlName="email"
              frmLowercase
              placeholder="CORREO PARA EL ENVIÓ DE NOTIFICACIONES"
              >
            </div>
          </div -->

          
          
      </div>
      <hr/>
      <form-porcentaje-beca 
        [formBeca]="principales"
        [hiddenBecas]="activarBeca">
      </form-porcentaje-beca>
      
    </form>
  `,
  providers:[LoopBackAuth, listadosService, validacionService, estudianteService, MessageService]
})


export class DatosPrincipalesComponent implements OnInit {
  @Input() principales: FormGroup
  @Input() minAnio: number = 20
  @Input() maxAnio: number = 2
  @Input() spinner: any  
  @Input() listaMails:any[] =[]

  /** Salida */
  @Output() emitDatosUsuario  = new EventEmitter()
  
  /** Variables del componenete */
  public identificaciones: any =[]
  public generos: any = []
  public maxLongitud: number = 13
  public minLongitud: number = 10
  /** Revisar para activar OJO */
  public activarBeca: boolean = false
 

  constructor(
    public listadosService: listadosService,
    private val : validacionService,
    private estudianteService: estudianteService
  ) { }

  ngOnInit() {
    
    this.spinner.isSpinnerVisible = true
    /** Busco el listado de identificador por el tipo  */
    this.listadosService.identificaciones(2).subscribe(
      result=>{
        this.identificaciones = result
        if(this.principales.get('tipo').value == null){
          this.principales.patchValue({ tipo : this.val.gruposDefecto(this.identificaciones,2)})
          this.onChangeTipo(this.val.gruposDefecto(this.identificaciones,2))
        }
          
      }
    )
    /** Busco el listado de generos */
    this.listadosService.grupos('G_GENERO').subscribe(
      result =>{
        this.generos = result.G_GENERO.orden
        if(this.principales.get('genero').value == null){
          this.principales.patchValue({ genero : this.val.gruposDefecto(this.generos,2)})
        }
          

        this.spinner.isSpinnerVisible = false
      }
    )
    this.activarBeca = this.val.accesoBecas()
    
  }

  public onCorreosNotificaciones($event:any){
    if($event.target.value == "") return null
    this.listaMails.push($event.target.value)
    this.principales.get('email').setValue(this.listaMails.toString())
    $event.target.value = ""
  }

  public deleteCorreoNotificacion(index:number){
    this.listaMails.splice(index, 1)
    this.principales.get('email').setValue(this.listaMails.toString())
  }

  /**
   * Configuro limites de la fecha que voy a mostrar y visualizo el calendario 
   *
   * @param {Object} d
   * @memberof DatosPrincipalesComponent
   */
  public onFechaNacimiento(d:any){
    d.minDate= {year: new Date().getFullYear() - this.minAnio, month: 1, day: 1}
    d.maxDate = {year: new Date().getFullYear() + this.maxAnio, month: 12, day: 31}
    d.toggle()
  }

  public onChangeTipo(event: any){
    let tipo = this.identificaciones.filter((x:any)=> x.id == event)[0]
    this.maxLongitud = tipo.maximo
    console.log("Datos tipo-->", tipo)
    this.minLongitud = tipo.minimo
  }
  
  public validarUsuarioIdentificacion(){
    if(!isNull(this.principales.get('identificacion').value) && this.principales.get('identificacion').value.length > 9){
      this.estudianteService.findIdentificacion(this.principales.get('identificacion').value).subscribe(
        usuario =>{
            if(!isNull(usuario))
              this.emitDatosUsuario.emit(usuario)
        }
      )
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/fichaEstudiante/datos-principales.component.ts